import { Map, List } from 'immutable';
import { 
  SET_NUMBER_OF_TEAM_MEMBERS,
  SET_LOADING,
  SET_ACCOUNT_STATS,
} from '@/Pages/Account/constants';


const initialState = Map({
  numberOfTeamMembers: 0,
  isLoading: false,
  isBillingLoading: false,
  isPaymentLoading: false,
  editingCardId: null,
  stats: {},
});

function settingsReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_NUMBER_OF_TEAM_MEMBERS: {
      return state.set('numberOfTeamMembers', action.numberOfTeamMembers);
    }

    case SET_LOADING: {
      return state.set('isLoading', action.isLoading);
    }

    case SET_ACCOUNT_STATS: {
      return state.set('stats', action.stats);
    }

    default:
      return state;
  }
}

export default settingsReducer;
